module.exports = __webpack_public_path__ + "img/tamanho-do-quadro.92b3a034.jpg";